import PropTypes from 'prop-types';

export const LegalEntityPropTypes = PropTypes.shape({
  periodName: PropTypes.string.isRequired,
  legalEntity: PropTypes.string,
  leDescription: PropTypes.string,
  enabledFlag: PropTypes.string,
  goldId: PropTypes.string,
  countryCode: PropTypes.string,
  usTaxType: PropTypes.string,
  localTaxType: PropTypes.string,
  esTaxType: PropTypes.string,
  esAltTaxType: PropTypes.string,
  branch: PropTypes.string,
  minorityPercentage: PropTypes.number,
  parent1: PropTypes.string,
  ownership1: PropTypes.number,
  parent2: PropTypes.string,
  ownership2: PropTypes.number,
  parent3: PropTypes.string,
  ownership3: PropTypes.number,
  parent4: PropTypes.string,
  ownership4: PropTypes.number,
  parent5: PropTypes.string,
  ownership5: PropTypes.number,
  parent6: PropTypes.string,
  ownership6: PropTypes.number,
  parent7: PropTypes.string,
  ownership7: PropTypes.number,
  parent8: PropTypes.string,
  ownership8: PropTypes.number,
  parent9: PropTypes.string,
  ownership9: PropTypes.number,
  parent10: PropTypes.string,
  ownership10: PropTypes.number,
  source: PropTypes.string.isRequired,
});

export const LegalEntitiesPropTypes = PropTypes.arrayOf(LegalEntityPropTypes);
